import { jdiVoting } from '@jdiyield/abi'
import { JDI_TOKEN, VOTE_CONTRACT } from '@jdiyield/constants'
import { BigNumber } from 'bignumber.js'
import Web3 from 'web3'

import { erc20ABI } from '../abi/abi'
import getNodeUrl from '../rpcRandom'
import { web3Contract } from '../web3'
import { Candidate, UserVote, VoteDetail, VoteTopic } from './jdiVote'

// const MAX_UINT = '115792089237316195423570985008687907853269984665640564039457584007913129639935'

const { abi } = jdiVoting

const convertBigNumber = (amount: string) => {
  try {
    const number = new BigNumber(amount).times(1e18).toFixed()
    return `${number}`
  } catch (e) {
    console.log(e)
  }
}

export const createTopic = async (
  name: string,
  candidates: [string],
  startTime: string,
  endTime: string,
  tokenContract: string
): Promise<boolean> => {
  try {
    const contract = await web3Contract(abi, VOTE_CONTRACT)
    const result = await contract.methods.createTopic(name, candidates, startTime, endTime, tokenContract).send()
    return result.status
  } catch (e) {
    return false
  }
}

export const getTopics = async (web3: Web3 = new Web3(getNodeUrl(56))): Promise<VoteTopic[]> => {
  try {
    const contract = new web3.eth.Contract(abi as any, VOTE_CONTRACT)
    const result = await contract.methods.getTopics().call()
    return result
  } catch (e) {
    return null
  }
}

export const getTopicById = async (id: string, web3: Web3 = new Web3(getNodeUrl(56))): Promise<VoteTopic> => {
  try {
    const contract = new web3.eth.Contract(abi as any, VOTE_CONTRACT)
    const result = await contract.methods.getTopic(id).call()
    return { ...result }
  } catch (e) {
    return null
  }
}

export const getVoteDetail = async (topicId: string, account: string): Promise<VoteDetail> => {
  try {
    const contract = await web3Contract(abi, VOTE_CONTRACT)
    const result = await contract.methods.getVoteDetail(topicId).call({ from: account })
    return { ...result }
  } catch (e) {
    return null
  }
}

export const getCandidates = async (topicId: string): Promise<[Candidate]> => {
  try {
    const contract = await web3Contract(abi, VOTE_CONTRACT)
    const result = await contract.methods.getCandidates(topicId).call()
    return result
  } catch (e) {
    return null
  }
}

export const getCurrentVoted = async (topicId: string): Promise<[Candidate]> => {
  try {
    const contract = await web3Contract(abi, VOTE_CONTRACT)
    const result = await contract.methods.getCandidateVoted(topicId).call()
    return result
  } catch (e) {
    return null
  }
}

export const getTotalVoted = async (topicId: string, web3: Web3 = new Web3(getNodeUrl(56))): Promise<[Candidate]> => {
  try {
    const contract = new web3.eth.Contract(abi as any, VOTE_CONTRACT)
    const result = await contract.methods.getTotalCandidateVoted(topicId).call()
    return result
  } catch (e) {
    return null
  }
}

export const getUserVotes = async (topicId: string, web3: Web3 = new Web3(getNodeUrl(56))): Promise<[UserVote]> => {
  try {
    const contract = new web3.eth.Contract(abi as any, VOTE_CONTRACT)
    const result = await contract.methods.getUserVotes(topicId).call()
    return result
  } catch (e) {
    return null
  }
}

export const deposit = async (
  web3: Web3,
  topicId: number,
  candidateId: number,
  amount: string,
  account: string
): Promise<[Candidate]> => {
  try {
    const contract = new web3.eth.Contract(abi as any, VOTE_CONTRACT)

    const result = await contract.methods.vote(topicId, candidateId, convertBigNumber(amount)).send({ from: account })
    return result
  } catch (e) {
    return null
  }
}

export const withdraw = async (web3: Web3, topicId: number, account: string): Promise<boolean> => {
  try {
    const contract = new web3.eth.Contract(abi as any, VOTE_CONTRACT)
    const result = await contract.methods.withdraw(topicId).send({ from: account })
    return result
  } catch (e) {
    return null
  }
}

export const balanceOfVote = async (walletAddress: string): Promise<string> => {
  try {
    const web3 = new Web3(Web3.givenProvider)
    const contract = new web3.eth.Contract(erc20ABI as any, JDI_TOKEN)
    const result = await contract.methods.balanceOf(walletAddress).call()
    return result
  } catch (e) {
    return '0'
  }
}
